import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetUserResponseBody,
  IApiUpdateUserPasswordRequestBody,
  IApiUpdateUserPasswordResponseBody,
  IApiUpdateUserRequestBody,
  IApiUpdateUserResponseBody,
  IApiUpdateUserTosRequestBody,
  IApiUpdateUserTosResponseBody,
} from './UsersApi.types';

export class UsersApi {
  public constructor(private client: ApiClient) {}

  public async get(userId: string): Promise<IApiGetUserResponseBody> {
    const request: IApiJsonRequest = {
      path: `/users/${userId}`,
      method: 'get',
    };

    const response =
      await this.client.fetchJson<IApiGetUserResponseBody>(request);

    return response.body;
  }

  public async update(
    userId: string,
    body: IApiUpdateUserRequestBody,
  ): Promise<IApiUpdateUserResponseBody> {
    const request: IApiJsonRequest = {
      method: 'put',
      path: `/users/${userId}`,
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateUserResponseBody>(request);

    return response.body;
  }

  public async updateTos(
    userId: string,
    body: IApiUpdateUserTosRequestBody,
  ): Promise<IApiUpdateUserTosResponseBody> {
    const request: IApiJsonRequest = {
      method: 'put',
      path: `/users/${userId}/optin`,
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateUserTosResponseBody>(request);

    return response.body;
  }

  public async updatePassword(
    body: IApiUpdateUserPasswordRequestBody,
  ): Promise<IApiUpdateUserPasswordResponseBody> {
    const request: IApiJsonRequest = {
      method: 'post',
      path: '/auth/changePassword',
      body,
    };

    const response =
      await this.client.fetchJson<IApiUpdateUserPasswordResponseBody>(request);

    return response.body;
  }
}
